import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No assets. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Loading assets data. Please wait. ")
const _hoisted_6 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-warning" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "form-group text-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "firstName" }, " First Name ", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "form-group text-left" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "lastName" }, " Last Name ", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-group text-left" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "email" }, " Email ", -1)
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-group text-left" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "password" }, " Password ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-12 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Password = _resolveComponent("Password")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    allowBack: false,
    title: "Grant Permissions",
    subtitle: "Please provide the required information."
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            class: "table-striped p-datatable-sm",
            value: _ctx.getFilteredItems,
            rows: 10,
            rowsPerPageOptions: [10, 20, 50],
            autoLayout: true,
            paginator: true,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control w-50",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                }, null, 512), [
                  [_vModelText, _ctx.mainSearch]
                ]),
                _createVNode("button", {
                  class: "btn btn-success btn-sm",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = true))
                }, " Add Admin + ")
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_4
            ]),
            loading: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "ID" }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, _toDisplayString(slotProps.data.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Email" }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, _toDisplayString(slotProps.data.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Fist Name",
                field: "firstName"
              }),
              _createVNode(_component_Column, {
                header: "Last Name",
                field: "lastName"
              }),
              _createVNode(_component_Column, {
                header: "Permmissions",
                class: "text-center"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("b", null, _toDisplayString(slotProps.data.permissionsCount) + " / " + _toDisplayString(Object.keys(_ctx.SitePermissionsEnum).length), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Status",
                class: "text-center"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, _toDisplayString(slotProps.data.isActive ? 'ENABLE' : 'DISABLE'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Actions",
                class: "text-center"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_router_link, {
                    to: {
                  name: 'permissions.admin.details',
                  params: { id: slotProps.data.id }
                }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_Dialog, {
            header: 'Add Admin',
            visible: _ctx.showModal,
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModal = $event)),
            style: { width: '50vw' },
            modal: true
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createVNode("input", {
                      id: "firstName",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.adminForm.props.firstName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.adminForm.props.firstName]
                    ]),
                    (_ctx.adminForm.controls.firstName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.adminForm.controls.firstName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createVNode("input", {
                      id: "lastName",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.adminForm.props.lastName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.adminForm.props.lastName]
                    ]),
                    (_ctx.adminForm.controls.lastName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_15, _toDisplayString(_ctx.adminForm.controls.lastName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createVNode("input", {
                      id: "email",
                      type: "email",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.adminForm.props.email = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.adminForm.props.email]
                    ]),
                    (_ctx.adminForm.controls.email.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString(_ctx.adminForm.controls.email.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode(_component_Password, {
                      style: {"width":"100%"},
                      inputStyle: "width:100%",
                      toggleMask: "",
                      feedback: false,
                      modelValue: _ctx.adminForm.props.password,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.adminForm.props.password = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_24,
                    (_ctx.adminForm.controls.password.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString(_ctx.adminForm.controls.password.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                    class: "btn btn-success",
                    disabled: _ctx.adminForm.invalid
                  }, " Save ", 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ])
    ]),
    _: 1
  }))
}